import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { EnumContexto } from '../../../domains/aya/interfaces/topic.interface';
import { CanActivateCliente } from './can-activate-cliente';
import { ClienteComponent } from './cliente.component';
import { ClienteFormComponent } from './form';


@NgModule({
    imports: [
        RouterModule.forChild([
            {
                path: '',
                canActivateChild: [CanActivateCliente],
                data: { contexto: EnumContexto.CadastroClientes },
                children: [
                    {path: '', component: ClienteComponent},
                    {path: 'novo', component: ClienteFormComponent},
                    {path: ':id', component: ClienteFormComponent}
                ]
            }
        ])
    ],
    exports: [
        RouterModule
    ],
    providers: [
        CanActivateCliente
    ]
})
export class ClienteRoutingModule { }
